import { nanoid } from 'nanoid'
//import * as pako from 'pako';
import { deflateSync, inflateSync, strToU8,strFromU8 } from 'fflate';
import { activePlayer, announce, catchupFully, catchupOneStep, changeView, choose, currentPlayer, debounce, flashIndicator, formatBytes, pause, waitMillis } from './ui';
import { fromByteArray, toByteArray } from 'base64-js';
import { getUsername, isMe, joinGame, listenToRequests, sendUpdate } from './net';
import { clone, ui, ui as uiStore, res, prefs, state } from './stores';
import { adoptFrame, popFrame } from './frames.js';
import { get } from 'svelte/store';
import { takeTurns, until } from './turns';
import * as jsonpatch from 'fast-json-patch';
import { doActionPause, resolveAction } from './parse';
import { addDBItem, closeMessage, deleteItem, getGame, getItem, getItems, pb, sendMessage, subscribeDB, unsubscribeDB, updateItem } from './anydb';
import { subscribe } from 'svelte/internal';
import { doAction, getCard, getPlayerIndex } from './game';
import { tick } from 'svelte';
import { mainURL } from './save';
import Bottleneck from 'bottleneck/light';
import { playSound } from './sounds';
import { conflictKind, decodePayload, encodePayload, nextVersion, patchAppliesTo, resolveRow } from './wire.js';
import { isAutoCancelled, queueIsIdle } from './sendqueue.js';

/* Bottleneck settings:
maxConcurrent: 1,
reservoir: 50,
reservoirRefreshInterval: 10 * 1000,
reservoirRefreshAmount: 50,
timeout: 5000,
highwater: 5, // Max number of items in queue – experiment with this!
*/
//

// Below is the configuration for pockethost.io – to avoid overloading
/*export let reactQueue = new Bottleneck({
    maxConcurrent: 1,
    reservoir: 50,
    reservoirRefreshInterval: 10 * 1000,
    reservoirRefreshAmount: 50,
    highWater: 5, // Max number of items in queue – experiment with this!
})*/

// Two queues, deliberately different.
//
// applyQueue (inbound): work that applies a received update. Each payload carries
// the whole state, so a newer one supersedes an older one — dropping the oldest
// when we fall behind is correct, and keeping the backlog short keeps us current.
//
// sendQueue (outbound): moves leaving this client. These are NOT interchangeable
// and there is nothing behind them, so this queue never expires or drops a job.
// It used to be the same object as the inbound queue, with a 5s expiry and a LEAK
// strategy — which meant a slow inbound apply silently deleted the moves you were
// trying to send.
export let applyQueue = new Bottleneck({
    maxConcurrent: 1,
    highWater: 20,
    strategy: Bottleneck.strategy.LEAK
});

export let sendQueue = new Bottleneck({
    maxConcurrent: 1,
    reservoir: 1000,                     // protects the server, not us
    reservoirRefreshInterval: 30 * 1000,
    reservoirRefreshAmount: 1000
    // no highWater, no strategy, no expiration: an outbound job is never dropped
});

// Kept as an alias so existing imports keep working.
export let reactQueue = applyQueue;

// Bottleneck rejects the promise when a job is dropped or errors. Nothing used to
// catch those, so drops surfaced as unhandled rejections and vanished.
export function queueJob(queue, label, job, options = false){
    if(queue === sendQueue) sendSeq++; // see updateGame(): which job is at the back
    let scheduled = options ? queue.schedule(options, job) : queue.schedule(job);
    return scheduled.catch(e => {
        console.log(`[db] queued job "${label}" did not run:`, e);
        netLog({text: `Error: ${label} never ran (${e && e.message ? e.message : e})`, data: e});
        if(queue === sendQueue) markSyncFailed(label, e);
    });
}

let myID = nanoid();

// Every write must be stamped, or echo suppression can't tell our own writes from
// the other player's: closeMessage and rollbackMessages used to omit it, leaving
// `lastUpdated` holding whatever the previous write set.
export function myUpdaterID(){
    return myID;
}

function untilIdle(queue){
    if(queueIsIdle(queue)) return Promise.resolve();
    return new Promise((resolve) => {
        queue.once('idle', () => {resolve();})
    })
}

// Waits for both directions. These used to be one queue, so a single wait covered
// both; callers still expect "everything has settled".
export async function untilQueueEmpties(){
    await Promise.all([untilIdle(sendQueue), untilIdle(applyQueue)]);
}

export function getCompressedState(state){
    //let compressed = pako.deflate(JSON.stringify(state));
    //return JSON.stringify(state);
    //if(state.startsWith(``))
    let compressed = deflateSync(strToU8(JSON.stringify(state)));
    //let decoder = new TextDecoder('utf8');
    //let encoded = btoa(decoder.decode(compressed));
    //return encoded;
    console.log(`compressed string ${formatBytes(fromByteArray(compressed).length)}, arr ${formatBytes(compressed.length)}, orig ${formatBytes(JSON.stringify(state).length)}`);
    return fromByteArray(compressed);
}

export function getDecompressedState(compressed){
    //return JSON.parse(compressed);
    let ba = toByteArray(compressed);
    let str = strFromU8(inflateSync(ba));
    //let str = pako.inflate(ba, {to: 'string'});
    //console.log('decomp', ba, str);
    return JSON.parse(str);
}


export async function addCurrentGame(state, ui){
    
    
    state.stateVersion = 1; // see nextStateVersion(): the receiver's drift check
    let compressed = encodePayload(state);
    //console.log('compressed state', compressed, formatBytes(compressed.length), getDecompressedState(compressed));
    let resToSave = {...get(res)};
    setLastState(state, compressed);
    setRowBase(state);
    delete resToSave.parsedCardText; // Just to make a bit smaller!
    delete resToSave.cachedTrawls; // ditto, and it would go stale against a reparse
    //console.log('lengths', compressed.length, getCompressedState(resToSave).length);
    const { success, error } = await addDBItem('current_games', {
        nanoid: state.gameID,
        host: state.hostUsername,
        public: state.advertised,
        changelist: [],
        state_compressed: compressed,
        res_compressed: getCompressedState(resToSave),
        captain1: state.players[0].captain,
        captain2: state.players[1].captain,
        captain1_username: state.hostUsername,
        captain2_username: state.hostUsername,
        activePlayer: state.players[0].captain,
        turn: 1,
        updatedBy: myID
    });

    if(error){
        console.log('Error uploading game', error);
        state.gameShared = false;
        return false;
    }
    state.dbID = success.id;
    state.gameShared = true;
    console.log('Game successfully uploaded');
    
    return true;
}

export const dbUpdateGame = updateGame; //debounce(updateGame, 200);

export async function setCaptainUsername(id, num, username){
    let toUpdate = {
        updatedBy: myID
    };
    toUpdate['captain'+num+'_username'] = username;
    const response = await updateItem('current_games', id, toUpdate);

    if(response.error){
        console.log('Error setting captain', response.error);
        return false;
    }
    return true;
}

export async function togglePublic(){
    state.update(state => {
        state.advertised = !state.advertised;
        return state;
    });
    if(!get(state).gameShared && get(state).advertised){
        if(await addCurrentGame(get(state), get(ui))){
            //$ui.synced = true;
            await listenToRequests(get(state).gameID);
            await subToUpdates(get(state).gameID);
            let id = get(state).dbID;
            res.update(r => {
                if(r.initialState) r.initialState.dbID = id;
                if(r.interimState && r.interimState.state) r.interimState.state.dbID = id;
                if(r.savedState) r.savedState.dbID = id;
                return r;
            })
        }
    }
    updateGame(get(state), get(state).choices.thisTurn, get(ui), 'public');
}

export async function makeInvite(captain){
    await navigator.clipboard.writeText(`${mainURL}?invite=${get(state).gameID}&captain=${encodeURIComponent(captain)}`);
    ui.update(ui => {
        ui.inviteMessages[captain] = true;
        return ui;
    })
    waitMillis(5000).then(() => {
        ui.update(ui => {
            delete ui.inviteMessages[captain];
            return ui;
        })
    })
}

let nlength = 500;

// Entries used to pin a reference to the whole payload — up to 500 whole game
// states held in memory — and ignored the pref that is supposed to control them.
export function netLog(item){
    let isProblem = typeof item.text == 'string' && /^(Error|Superseded|Diff out of step)/.test(item.text);
    if(!isProblem && !get(prefs).logNetEvents && !get(ui).showingNetLog) return;
    let size = 0;
    try{
        if(item.data !== undefined) size = JSON.stringify(item.data).length;
    }catch(e){
        size = 0;
    }
    ui.update(ui => {
        ui.netLog = [{text: item.text, size, time: new Date()}, ...ui.netLog];
        if(ui.netLog.length > nlength) ui.netLog = ui.netLog.slice(0, nlength);
        return ui;
    })
}

// A send that never lands used to be invisible: the local state advanced and
// nothing on screen said otherwise. This is what the game screen renders as a
// persistent "not saved" badge.
export function markSyncFailed(what, error){
    ui.update(ui => {
        ui.syncFailed = {
            what,
            message: error && error.message ? error.message : String(error || 'unknown error'),
            when: Date.now()
        };
        return ui;
    })
}

export function clearSyncFailed(){
    if(!get(ui).syncFailed) return;
    ui.update(ui => {
        ui.syncFailed = false;
        return ui;
    })
}

// Push, don't pull. The failure this recovers from is "my move never reached the
// server", so pulling first would overwrite the very change we are trying to save.
// Pulling is a separate, deliberate action (Pull state from server).
export async function retrySync(){
    clearSyncFailed();
    sendUpdate(true, false, true);
}

// Set only by useServerState(), and consumed by the very next full state we apply:
// the whole point of that choice is to accept a state we would otherwise refuse.
let acceptOlderState = false;

// Somebody wrote the game row from a copy older than ours, so their write cannot
// contain our most recent move. Neither side is safe to pick automatically — taking
// theirs drops our move, keeping ours drops whatever they just did — so this stops
// and asks. Without it the older state was simply applied and the move vanished
// with nothing on screen to say so.
function markSyncConflict(kind, incomingVersion, heldVersion){
    console.log('[db] conflicting write landed on the game row', {kind, incomingVersion, heldVersion});
    netLog({text: `Error: conflicting write (${kind}: server v${incomingVersion}, we hold v${heldVersion})`, data: {kind, incomingVersion, heldVersion}});
    ui.update(ui => {
        ui.syncConflict = {kind, incomingVersion, heldVersion, when: Date.now()};
        return ui;
    })
}

export function clearSyncConflict(){
    if(!get(ui).syncConflict) return;
    ui.update(ui => {
        ui.syncConflict = false;
        return ui;
    })
}

// Keep our version: push it back over theirs. It is already the newer one, so the
// other client will take it on the next broadcast.
export async function keepMyState(){
    clearSyncConflict();
    sendUpdate(true, false, true);
}

// Take theirs, losing whatever we had that they did not.
export async function useServerState(){
    clearSyncConflict();
    acceptOlderState = true;
    await refreshSync(true);
}

export async function bootOff(username){
    if(!confirm(`Are you sure you want to remove ${username} from the game?`)) return;
    state.update(s => {
        for(let p of s.players){
            if(p.username == username) p.username = s.hostUsername;
        }
        return s;
    });
    await sendMessage('current_games', get(state).gameID, {
        type: 'bye_bye',
        username
    })
}

let debugNoDiffs = false;// true;
let debugAlwaysState = true;

export function updateGame(state, choices, ui, update = 'all', extras = false, rightNow = false){
    //let resToSave = {...get(res)};
    //delete resToSave.cachedParser;
    if(!state.dbID){
        alert('undefined game ID!');
        state.dbID = 'cancelled';
    }
    if(state.dbID == 'cancelled') return; // no longer attempts to sync
    // Aug 2025: if we have issues with messages not getting through,
    // uncomment the below to override the active player limitation
    if(!isMe(state.activePlayer) && update != 'force' /* && (!extras || !extras.hasOwnProperty('currentMessage') */){
        console.log('Not updating game because not active', state, choices, update);
        return;
    }
    //console.log('Sending game update '+state.activePlayer, state, choices, update);
    let force = false;
    if(update == 'force'){
        update = 'all';
        force = true;
    }
    console.log('[db]: making update inc. whenSaved', clone(state));
    //console.trace();
    // Everything except the state blob. Deflating the state costs real time on a
    // 291kB object, so it is added below only once we know this update keeps it —
    // it used to be built unconditionally and then deleted again on diff updates.
    // The version stamp goes on at the same point, so the "nothing has changed"
    // checks below compare like with like: stamping up here would make every state
    // differ from the last one by the stamp alone, and nothing would ever be
    // recognised as a no-op again.
    let toUpdate = {
        public: state.advertised,
        changelist: choices,
        state_compressed: '',
        changediffs_compressed: '',
        turn: state.turn,
        activePlayer: state.players[state.activePlayer].captain,
        whenSaved: ((new Date()).toISOString()),
        updatedBy: myID
    };

    let sendsFullState = true;

    if(update != 'all'){
        for(let k of Object.keys(toUpdate)){
            if(['whenSaved', 'updatedBy', 'activePlayer'].includes(k)) continue;
            if(debugNoDiffs){
                // Send only full state, not diffs
                 if(k == 'state_compressed') continue;
                 if(k == 'changediffs_compressed') delete toUpdate[k];
            }
            if(!update.includes(k)) delete toUpdate[k]; // Only update the listed things
        }
        sendsFullState = Object.prototype.hasOwnProperty.call(toUpdate, 'state_compressed');
    }

    if(extras){
        if(extras.res){
            extras.res_compressed = getCompressedState(extras.res);
            delete extras.res;
        }
        toUpdate = {...toUpdate, ...extras};
    }

    // A diff needs the row's full state to be made against. Without one (just
    // joined, or the last full write failed) this update carries the full state.
    if(!sendsFullState && toUpdate.changelist && lastState && !currentRowBase(state)){
        sendsFullState = true;
    }

    // `state` still carries the version we last sent, so an unchanged state
    // produces an empty op list. Computing it is far cheaper than the deflate (and
    // the round trip) it can save.
    let ops = lastState ? jsonpatch.compare(lastState, state) : false;
    let samePlayer = lastState && toUpdate.activePlayer == lastState.players[lastState.activePlayer].captain;

    if(sendsFullState){
        if(!extras.res && ops && ops.length == 0 && samePlayer && !['turn', 'public'].some(k => toUpdate.hasOwnProperty(k))){
            // Nothing new, so exit
            console.log('not sending full state update because nothing has changed');
            return;
        }
        state.stateVersion = nextStateVersion(state);
        toUpdate.state_compressed = encodePayload(state);
        // A new blob invalidates whatever diff the row holds: clear it, so the row
        // never pairs this state with a diff made against an older one.
        toUpdate.changediffs_compressed = '';
        setLastState(state, toUpdate.state_compressed);
        setRowBase(state);
    }else if(toUpdate.changelist && lastState){
        if(!extras.res && ops.length == 0 && samePlayer && !['activePlayer', 'turn', 'public'].some(k => toUpdate.hasOwnProperty(k))){
            // Nothing new, so exit
            console.log('not sending changelist update because nothing has changed');
            return;
        }
        // A diff is only meaningful against the exact state it was computed from,
        // so it travels with the version it applies to. The receiver checks that
        // against what it holds and pulls a full state if they have drifted — which
        // is what lets this branch send a diff *instead of* the whole state. It used
        // to attach the full state as well "just in case", so there was no small
        // update anywhere in the protocol.
        state.stateVersion = nextStateVersion(state);
        // Against the row's full state, not the previous diff: then the row alone
        // (blob + this diff) is always the latest state, and a receiver that missed
        // a diff loses nothing — the next one carries everything since the blob.
        let base = currentRowBase(state);
        toUpdate.changediffs_compressed = encodePayload({
            base: base.stateVersion,
            version: state.stateVersion,   // the receiver stamps this on after applying
            patch: jsonpatch.compare(base, state)
        });
        // `false` = don't spend a full deflate recomputing the encoded form; it is
        // only used by the full-state branch, which recomputes it when it next runs.
        setLastState(state, false); // what we hold; the row's blob (rowBase) is unchanged
    }

    
    
    console.log('queueing db update to send: current player '+state.currentPlayer, toUpdate, update, sendQueue.counts)

    
    // rightNow used to bypass the queue, so it ran alongside queued writes to the
    // same record and PocketBase aborted whichever started first — including a
    // queued reaction offer or response, which was then logged as "superseded"
    // and never arrived. Every write now goes through the queue, in order.
    //
    // Per-click continuation writes would pile up that way, so one that is still
    // waiting at the back of the queue absorbs the next. Only at the back: moving
    // a newer state ahead of a queued write would let that older state land last.
    if(rightNow && pendingImmediate && pendingImmediate.seq === sendSeq && !pendingImmediate.started){
        pendingImmediate.toUpdate = {...pendingImmediate.toUpdate, ...toUpdate};
        return pendingImmediate.done;
    }

    // ui is a plain snapshot here, so bump the counter through the store or the
    // Network pane never sees it move.
    uiStore.update(u => {
        u.queuedSyncs++;
        return u;
    })
    let job = {toUpdate, started: false};
    // No expiration: an outbound move is never dropped for being slow.
    job.done = queueJob(sendQueue, `update ${Object.keys(toUpdate).join(', ')}`, async () => {
        job.started = true;
        let ok = await pushUpdate(state.dbID, job.toUpdate);
        // The row never got this blob, so diffs against it would be refused
        // everywhere: make the next update a full state instead.
        if(!ok && job.toUpdate.state_compressed) rowBase = false;
        return ok;
    });
    job.seq = sendSeq;
    pendingImmediate = rightNow ? job : false;
    return job.done;
    
    //func();

    /*const response = await updateItem('current_games', toUpdate, 'nanoid', state.gameID);

    if(response.error){
        console.log('Error updating game', response.error);
        return false;
    }
    return true;*/
}

export let numSyncsThisSession = 0;
export let numSyncsQueued = 0;

// Bumped by every outbound queueJob, messages included, so a pending job whose
// seq still matches is known to be the last thing queued.
let sendSeq = 0;
let pendingImmediate = false;

const SEND_ATTEMPTS = 3;
// Without the old 5s job expiry nothing else bounds a request, and one that
// never answers would hold every later move behind it with no badge.
const SEND_TIMEOUT_MS = 30 * 1000;

// One failed HTTP call used to be one permanently lost move: no retry, and the
// only trace was a console line.
export async function pushUpdate(id, toUpdate){
    let what = Object.keys(toUpdate).join(', ');
    let lastError;

    for(let attempt = 1; attempt <= SEND_ATTEMPTS; attempt++){
        let controller = new AbortController();
        let timedOut = false;
        let timer = setTimeout(() => {
            timedOut = true;
            controller.abort();
        }, SEND_TIMEOUT_MS);
        let response;
        try{
            response = await updateItem('current_games', id, toUpdate, true, {requestKey: null, signal: controller.signal});
        }finally{
            clearTimeout(timer);
        }

        if(!response.error){
            console.log('[db] updated game');
            netLog({text:`Sent ${what}`, data: toUpdate});
            uiStore.update(u => {
                u.numSyncs++;
                return u;
            })
            clearSyncFailed();
            flashIndicator('output');
            return true;
        }

        lastError = response.error;

        if(!timedOut && isAutoCancelled(response.error)){
            console.log('[db] update superseded by a newer one, dropping', what);
            netLog({text:`Superseded: ${what}`, data: response.error});
            return true;
        }

        console.log(`Error updating game (attempt ${attempt}/${SEND_ATTEMPTS})`, response.error, response.error.originalError);
        netLog({text:`Error updating ${what} (attempt ${attempt}): ${response.error.originalError}`, data: response.error});

        if(attempt < SEND_ATTEMPTS) await waitMillis(500 * Math.pow(2, attempt - 1));
    }

    markSyncFailed(what, lastError);
    return false;
}

export async function deleteLiveGame(){
    // i.e. remove it from the shared multiplayer db – e.g. at the end of the game
    await deleteItem('current_games', 'nanoid', get(state).gameID);
}

// Only what the lobby table draws. Unprojected, this pulled state_compressed,
// res_compressed and pastMessages for every live game on the server.
const LOBBY_FIELDS = [
    'id', 'nanoid', 'host', 'public',
    'captain1', 'captain2', 'captain1_username', 'captain2_username',
    'activePlayer', 'turn', 'whenSaved', 'created', 'updated'
];

export async function getCurrentGames(){
    const {data, error} = await getItems('current_games', false, {column: 'whenSaved', desc: true}, LOBBY_FIELDS);
    if(error){
        console.log('Error loading games', error);
        throw error;
    }
    return data;
}

let lastUpdated;
let lastState;
let lastStateC;
// The full state the game row holds — the one diffs are made against. It changes
// only when a full state is written or received; diffs leave it alone.
let rowBase = false;

function setRowBase(s){
    rowBase = clone(s);
}

function currentRowBase(forState = get(state)){
    if(!rowBase || typeof rowBase.stateVersion != 'number') return false;
    if(forState && rowBase.gameID != forState.gameID) return false;
    return rowBase;
}

// Monotonic per game, carried inside the state itself so it needs no new column.
// The receiver uses it to tell "this diff applies to what I hold" from "we have
// drifted, fetch the whole thing".
function nextStateVersion(s){
    return nextVersion(s.stateVersion, lastState ? lastState.stateVersion : false);
}

// `compressed` may be the already-encoded payload (reuse it), omitted (encode now),
// or false (leave it unknown rather than pay for a deflate we don't need).
export function setLastState(s, compressed = undefined){
    lastState = clone(s);
    if(compressed === false) lastStateC = false;
    else if(compressed === undefined) lastStateC = encodePayload(s);
    else lastStateC = compressed;
}

export function queuedReact(payload, force = false, first = false){
    queueJob(applyQueue, 'apply incoming update', async () => {
        await reactToDB(payload, force, first);
        await tick();
    });
}

let whenLastSynced = Date.now();
export let lastSynced = () => whenLastSynced;

export async function reconnectGame(){
    try{
        await unsubscribeDB('current_games', 'nanoid', get(state).gameID);//pb.unsubscribe(get(state).gameID);
        await subToUpdates(get(state).gameID);
        await refreshSync(true);
    }catch(e){
        alert('Unable to reconnect game: '+e.message);
    }
}

export async function refreshSync(force = false){
    try{
        let game = await getGame('current_games', get(state).gameID);
        //reactQueue.clear(); // So as not to interrupt
        /*reactQueue.add(async () => {
            await reactToDB({
                new: game,
                old: {}
            }, force); // Do we want to force first-time too? Maybe not for now
            await tick();
        });*/
        // The whole row: its blob plus its diff is the latest state (resolveRow).
        // Dropping the diff handed back the blob alone, often versions old, which
        // the conflict check then reported as an overwrite.
        await reactToDB({
            new: game,
            old: {}
        }, force);
    }catch(e){
        console.log('Unable to refresh', e.message);
    }
    
}

let refreshInterval;

const CATCHUP_WAIT_MS = 20 * 1000;

// A diff is only valid against the exact state it was built from. `base` says
// which version that was; if we hold something else we have drifted, and the only
// safe move is to pull the whole state rather than apply a patch to the wrong
// baseline. Legacy payloads carry no version, so they keep the old behaviour.
function applyIncomingPatch(incomingPatch){
    if(!incomingPatch || !incomingPatch.patch) return false;
    // A versioned diff is made against the row's full state, so that is what it
    // applies to. A legacy one (no base) keeps the old behaviour: our last state.
    let versioned = typeof incomingPatch.base == 'number';
    let target = versioned ? currentRowBase() : lastState;
    if(!target){
        // Nothing to apply a patch to yet.
        queueJob(applyQueue, 'resync before first diff', async () => {
            await refreshSync(true);
        });
        return false;
    }

    let held = target.stateVersion;
    if(!patchAppliesTo(incomingPatch, held)){
        console.log('[db] diff does not match the state we hold - pulling full state', {held, base: incomingPatch.base});
        netLog({text: `Diff out of step (have v${held}, needs v${incomingPatch.base}): pulling full state`, data: incomingPatch});
        queueJob(applyQueue, 'resync after diff drift', async () => {
            await refreshSync(true);
        });
        return false;
    }

    let applied = false;
    state.update(s => {
        let backup = clone(s);
        let next = clone(target);
        try{
            jsonpatch.applyPatch(next, incomingPatch.patch);
        }catch(e){
            console.log("Error patching state: trying to continue...", e);
            return backup;
        }
        // Carried alongside rather than as a patch op: `replace` on a state that
        // has no stateVersion yet (a game started before this existed) throws.
        if(typeof incomingPatch.version == 'number') next.stateVersion = incomingPatch.version;
        applied = true;
        return next;
    })

    if(applied) setLastState(get(state), false);
    return applied;
}

export async function reactToDB(payload, force = false, first = false){
    // Only run this once at a time (is there a better way to do this?)
    /*if(!get(ui).synced){
        console.log('new sync incoming – waiting for previous to finish')
        await until(_ => get(ui).synced);
        console.log('ok, ready to sync')
    }*/
    /*ui.update(ui => {
        ui.synced = false;
        return ui;
    })
    await tick();*/
    // Subscriptions used to outlive the game they belonged to: joining a second
    // game left the first one live, and nothing here checked which game a payload
    // was for, so a move in the game you left overwrote the one you are in.
    let payloadGame = payload.new.nanoid || payload.old.nanoid;
    if(payloadGame && get(state).gameID && payloadGame != get(state).gameID){
        console.log('[db] ignoring update for a different game', payloadGame, get(state).gameID);
        return;
    }

    if(payload.new.updatedBy){
        lastUpdated = payload.new.updatedBy;
    }/*else if(payload.old.updatedBy){
        lastUpdated = payload.old.updatedBy;
    }*/
    //console.log('checking who updated', myID, lastUpdated)
    if(force || lastUpdated != myID){ // Don't listen to your own updates
        //if(refreshInterval) clearInterval(refreshInterval);
        cancelPolling();
        whenLastSynced = Date.now();
        netLog({text: `Received update: ${Object.keys(payload.new).join(', ')}`, data: payload});
        flashIndicator('input');
        let incomingPatch = payload.new.changediffs_compressed ? decodePayload(payload.new.changediffs_compressed) : false;
        if(payload.new.state_compressed){
            let rowState = decodePayload(payload.new.state_compressed);
            if(!rowState.dbID && get(state).dbID && get(state).gameID == rowState.gameID) rowState.dbID = get(state).dbID; // save just in case
            let newState = rowState;
            if(incomingPatch){
                // The row's blob plus its diff is the latest state. On a first load
                // the player whose turn it is replays the changelist onto the blob
                // instead (below), so it takes the blob alone.
                if(!(first && isMe(currentPlayer()))) newState = resolveRow(rowState, incomingPatch, jsonpatch.applyPatch);
                incomingPatch = false; // consumed with the blob, or stale against it
            }

            // On a first load the server is authoritative by definition, and after
            // the player has explicitly chosen "use the server's copy" we are being
            // asked for exactly this. Otherwise a conflicting write landed on the
            // row and we must not quietly adopt it over our own move.
            if(!first && !acceptOlderState && lastState){
                // Only computed when the versions match, which is the rare
                // re-delivery case — everything else is decided on version alone.
                let sameVersion = newState.stateVersion === lastState.stateVersion;
                let differs = sameVersion && jsonpatch.compare(lastState, newState).length > 0;
                let kind = conflictKind(newState.stateVersion, lastState.stateVersion, differs);
                if(kind){
                    markSyncConflict(kind, newState.stateVersion, lastState.stateVersion);
                    return;
                }
            }
            acceptOlderState = false;

            setLastState(newState, newState === rowState ? payload.new.state_compressed : false);
            setRowBase(rowState);
            /*if(Array.isArray(get(state).workingLog) && !Array.isArray(newState.workingLog)){
                await doActionPause(); // So workinglog doesn't disappear immediately
            }*/
            ui.update(ui => {
                ui.loadedChoices = []; // To reset any carryover
                return ui;
            })
            state.update(s => {
                return newState;
            })
            //if(!payload.new.changelist) await doActionPause();
        }
        // A diff that arrived without a blob: a live incremental update.
        let willUseDiffs = !!incomingPatch;

        if(payload.new.res_compressed){
            let remoteRes = getDecompressedState(payload.new.res_compressed);
            res.update(r => {
                return {
                    ...r,
                    ...remoteRes,
                    botCharts: r.botCharts,
                    cards: r.cards,
                    parsedCardText: r.parsedCardText,
                    atCards: {...(remoteRes.atCards || {}), ...(r.atCards || {})},
                    atOps: {...(remoteRes.atOps || {}), ...(r.atOps || {})}
                };
            });
        }

        if(payload.new.activePlayer){
            // set for handover etc. Should happen anyway but let's see...!
            // Disabling this seemed to cause issues. Why??
            let ap = get(state).players.findIndex(p => p.captain == payload.new.activePlayer);
            if(ap != -1){
                state.update(s => {
                    s.activePlayer = ap;
                    return s;
                })
            }
        }
        
        if(payload.new.captain1_username){
            playSound('joined');
            state.update(s => {
                s.players[0].username = payload.new.captain1_username;
                return s;
            })
            res.update(r => {
                if(r.savedState) r.savedState.players[0].username = payload.new.captain1_username;
                for(let p of r.prevStates || []){
                    p.players[0].username = payload.new.captain1_username; // So  not lost on undo
                }
                return r;
            })
        }
        if(payload.new.captain2_username){
            playSound('joined');
            state.update(s => {
                s.players[1].username = payload.new.captain2_username;
                return s;
            })
            res.update(r => {
                if(r.savedState) r.savedState.players[1].username = payload.new.captain2_username;
                for(let p of r.prevStates || []){
                    p.players[1].username = payload.new.captain2_username; // So  not lost on undo
                }
                return r;
            })
        }
        if(payload.new.changelist){
            if(first && isMe(currentPlayer())){ //  was activePlayer()
                // Need to actually apply all the actions
                // Only do this on first load
                ui.update(ui => {
                    ui.loadedChoices = payload.new.changelist;
                    if(ui.loadedChoices.length == 0 || get(state).choices.thisTurn.length == ui.loadedChoices.length) ui.catchingUp = false;
                    return ui;
                })
                if(get(ui).catchingUp){
                   // console.log('replacing previous catchup');
                    console.log('Waiting for previous catchup to finish');
                    // This holds the apply queue's only slot. Untimed, one stuck
                    // catch-up parked every inbound update behind it indefinitely.
                    let finished = await until(_ => !get(ui).catchingUp, CATCHUP_WAIT_MS);
                    if(!finished){
                        console.log('Previous catchup did not finish in time: continuing anyway');
                        netLog({text: 'Previous catch-up timed out; continuing', data: {}});
                        ui.update(u => {
                            u.catchingUp = false;
                            return u;
                        })
                    }
                    console.log('Previous catchup finished');
                    /*ui.update(ui => {
                        ui.waiting = []; // To ditch old stuff!
                        ui.catchingUp = false;
                        return ui;
                    })
                    takeTurns();*/
                }
                if(payload.new.changelist.length > 0){
                    console.log('catching up', clone(payload.new.changelist));
                   // await catchupFully();
                   await catchupOneStep(); // Should be enough?
                   console.log('caught up');
                }
            }else if(willUseDiffs){
                applyIncomingPatch(incomingPatch);
            }else{
                //console.log('no changelist to apply');
            }
            //await doActionPause();
        } 
        if(payload.new.pastMessages){
            state.update(s => {
                s.pastMessages = getDecompressedState(payload.new.pastMessages);
                return s;
            })
        }
        // Test for the key, not for truthiness. "No current message" is an empty
        // string, so the truthy test meant a *cleared* message never propagated:
        // the other client kept the answered offer forever and every later offer
        // matched it and waited for a reply that had already been delivered.
        if(Object.prototype.hasOwnProperty.call(payload.new, 'currentMessage')){
            let data = payload.new.currentMessage;
            state.update(s => {
                s.currentMessage = data || '';
                return s;
            })
        }
        if(payload.new.currentMessage){
            // A message to respond to!
            let data = payload.new.currentMessage;
            // !! TODO the below should go within game-specific logic really
            if(data.type == 'effect_offer'){
                let {reactingP, generatingP, reactionCard, effect, attack} = data;
                if(!isMe(reactingP)) return; // Only answer reaction requests to you
                
                state.update(s => {
                    s.activePlayer = reactingP;
                    return s;
                });
                console.log('received effect offer', get(state).activePlayer);
                res.update(r => {
                    r.savedState = clone(get(state));
                    return r;
                })
                let owner = get(state).players[reactingP];
                let gen = get(state).players[generatingP];
                //let p = get(state).players[generatingP];
                let card = getCard(reactionCard);
                let origView = get(ui).viewing; 
                changeView(reactingP);
                playSound('effect_offer');
                // or gen? or reactingP?
                // Jan 2026: I suspect one issue with the ping-pong Attack Reactions is that 
                // the second-layer effect offer is getting stuck in the queue
                // because of the below await calling before this func resolves
                // So postpone it

                let runAfterwards = async () => {
                    // Resolve in the offering client's frame: "it" may be its card, an earlier
                    // action's result or a reaction's trigger, none of which exist here otherwise
                    let token = data.frame ? adoptFrame(data.frame) : null;
                    let response;
                    try{
                        response = await resolveAction(owner, card, effect, attack);
                    }finally{
                        if(token !== null) popFrame(token);
                    }
                    if(response && response.p){
                        response.p = getPlayerIndex(response.p);
                    }else{
                        response = {
                            p: generatingP,
                            effect
                        }
                    }
                    
                    // Not await to see
                    console.log('sending response', get(state).activePlayer)
                    await sendMessage('current_games', get(state).gameID, {
                        type: 'effect_response',
                        generatingP,
                        response,
                        offerNum: get(state).offerCounter
                    });
                    
                    state.update(s => {
                        s.activePlayer = generatingP;
                        return s;
                    })
                    console.log('player changed', get(state).activePlayer)

                    changeView(origView);
                }
                queueMicrotask(runAfterwards); // could just call directly?
            }else if(data.type == 'effect_response'){
                if(!isMe(data.generatingP)) return;

                // Update state to what we got back, if possible
                // If we were sent a whole state, that will already have come through.
                if(willUseDiffs) applyIncomingPatch(incomingPatch);

                state.update(s => {
                    s.activePlayer = data.generatingP;
                    return s;
                })
                res.update(r => {
                    r.savedState = clone(get(state));
                    return r;
                })
                let response = data.response;
                response.p = get(state).players[response.p];
                //await doActionPause();
                let rf = get(ui).reactionFunc[0];
                console.log('rf is', rf);
                ui.update(ui => {
                    ui.reactionFunc = ui.reactionFunc.slice(1);
                    return ui;
                })
                await closeMessage('current_games', get(state).gameID, get(state).dbID);
                playSound('effect_response');
                console.log('rf is', rf);
                if(!rf){
                    await pause(`Got lost in reaction logic: I will attempt to recover, but watch out for any mistakes that need correcting manually`);
                    queueMicrotask(() => {
                        takeTurns();
                    })
                    return;
                }
                rf(response);
            }else if(data.type == 'reaction_offer'){
                let {reactingP, generatingP, reactionCard, effect, attack, manAuto} = data;
                if(!isMe(reactingP)) return; // Only answer reaction requests to you
                state.update(s => {
                    s.activePlayer = reactingP;
                    return s;
                });
                res.update(r => {
                    r.savedState = clone(get(state));
                    return r;
                })
                let owner = get(state).players[reactingP];
                playSound('effect_offer');
                //let p = get(state).players[generatingP];
                let runAfterwards = async () => {
                    let card = reactionCard; //getCard(reactionCard);
                    let response = await doAction(owner, 'reaction', {p: generatingP, attack, card, type: data.action, effect, params: data.params, manAuto: data.manAuto});
                    if(response && response.p){
                        response.p = getPlayerIndex(response.p);
                    }else{
                        response = {
                            p: generatingP,
                            type: data.action,
                            params: data.params
                        }
                    }
                    // Not await to see
                    
                    await sendMessage('current_games', get(state).gameID, {
                        type: 'reaction_response',
                        generatingP,
                        response,
                        offerNum: get(state).offerCounter
                    })

                    state.update(s => {
                        s.activePlayer = generatingP;
                        return s;
                    })
                };
                queueMicrotask(runAfterwards);
            }else if(data.type == 'reaction_response'){
                if(!isMe(data.generatingP)) return;

                // If we were sent a whole state, that will already have come through.
                if(willUseDiffs) applyIncomingPatch(incomingPatch);

                state.update(s => {
                    //s = data.state;
                    s.activePlayer = data.generatingP;
                    return s;
                })
                res.update(r => {
                    r.savedState = clone(get(state));
                    return r;
                })
                let response = data.response;
                response.p = get(state).players[response.p];
                let rf = get(ui).reactionFunc[0];
                ui.update(ui => {
                    ui.reactionFunc = ui.reactionFunc.slice(1);
                    return ui;
                })
                await closeMessage('current_games', get(state).gameID, get(state).dbID);
                playSound('effect_response');
                if(!rf){
                    await pause(`Got lost in reaction logic: I will attempt to recover, but watch out for any mistakes that need correcting manually`);
                    queueMicrotask(() => {
                        refreshSync();
                    });
                }else{
                    rf(response);
                }
            }else if(data.type == 'bye_bye'){
                if(get(prefs).username == data.username){
                    await pause(`You have been booted off this game: goodbye`);
                    get(ui).backToSetup();
                }
            }
        }
        
    }else{
        netLog({text: `(Received own update: ${Object.keys(payload.new).join(', ')})`, data: payload});
    }
    addPolling();
    /*ui.update(ui => {
        ui.synced = true;
        return ui;
    })
    await tick();*/
}

let pollTimer;
let apSubscription;

let extraPolling = false;

export function cancelPolling(){
    if(!extraPolling) return;
    if(pollTimer) clearInterval(pollTimer);
    pollTimer = 0;
}

export function addPolling(){
    if(!extraPolling) return;
    let pollInterval = 1 * 1000;
    cancelPolling();

    pollTimer = setInterval(() => {
        if(isMe(get(state).activePlayer)){
             apSubscription = state.subscribe(s => {
                if(!isMe(s.activePlayer)){
                    if(apSubscription) apSubscription();
                    addPolling();
                }
            })
            return;
        }else{
            refreshSync();
            addPolling();
        }
    }, pollInterval)
}

// Held so joining another game replaces this subscription instead of stacking a
// second live one on top of it.
let unsubscribeCurrent = false;

export async function unsubFromUpdates(){
    if(!unsubscribeCurrent) return;
    let un = unsubscribeCurrent;
    unsubscribeCurrent = false;
    try{
        await un();
    }catch(e){
        console.log('Unable to unsubscribe cleanly', e);
    }
}

// Returns true only if we are actually listening. A failure here used to be
// swallowed, so the game opened normally and then silently never synced.
export async function subToUpdates(id){
    await unsubFromUpdates();
    const result = await subscribeDB('current_games', 'nanoid', id, queuedReact);

    if(!result || result.error){
        markSyncFailed('subscribe to game updates', result && result.error);
        return false;
    }

    unsubscribeCurrent = result.unsubscribe;
    addPolling();
    return true;
}
